import { createContext } from "react";
import { User } from "firebase/auth";
import { Firestore } from "firebase/firestore";

// type for the context
type contextType = {
  user?: User | null; // change this in the future
  setUser?: React.Dispatch<React.SetStateAction<User | null>>;
  loggedIn?: boolean;
  db?: Firestore | null;
};

const UserContext = createContext<contextType>({}); // context to be exported
export default UserContext;
